export function getConnectedTenantsForFilter(request, schema) {
  const tenantFilter = request.queryParams['filter[tenant]'] ?? request.queryParams['filter[tenant-roles.tenant]'];
  const propertyFilter = request.queryParams['filter[property]'];

  if (tenantFilter) {
    return tenantFilter
      .split(',')
      .map((id) => schema.tenants.find(id))
      .filter((tenant) => tenant.location);
  } else if (propertyFilter) {
    return schema.tenants.where({ propertyId: propertyFilter }).models.filter((tenant) => tenant.location);
  } else {
    return [];
  }
}
